/**
 * AppParameters.ts
 */
export class AppParameters {
    constructor(primaryNode, deviceType) {
        this.primaryNode = primaryNode;
        this.deviceType = deviceType;
    }
    setAccessToken(value) {
        this.accessToken = value;
    }
    setContentRoot(value) {
        this.contentRoot = value;
    }
    getPrimaryNode() {
        return this.primaryNode;
    }
    getAccessToken() {
        return this.accessToken;
    }
    getContentRoot() {
        return this.contentRoot;
    }
    getDeviceType() {
        return this.deviceType;
    }
}
//# sourceMappingURL=AppParameters.js.map